import * as React from "react";

function ArrowIcon(props) {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.9373 3.91668L16.4373 9.41668C16.5207 9.50001 16.5798 9.59029 16.6148 9.68751C16.6493 9.78474 16.6665 9.8889 16.6665 10C16.6665 10.1111 16.6493 10.2153 16.6148 10.3125C16.5798 10.4097 16.5207 10.5 16.4373 10.5833L10.9373 16.0833C10.7846 16.2361 10.5937 16.3161 10.3648 16.3233C10.1354 16.33 9.93734 16.25 9.77067 16.0833C9.604 15.9306 9.51706 15.7397 9.50984 15.5108C9.50317 15.2814 9.58317 15.0833 9.74984 14.9167L13.8332 10.8333L4.52067 10.8333C4.28456 10.8333 4.0865 10.7536 3.9265 10.5942C3.76706 10.4342 3.68734 10.2361 3.68734 10C3.68734 9.7639 3.76706 9.56612 3.9265 9.40668C4.0865 9.24668 4.28456 9.16668 4.52067 9.16668L13.8332 9.16668L9.74984 5.08335C9.59706 4.93057 9.51706 4.73612 9.50984 4.50001C9.50317 4.2639 9.58317 4.06946 9.74984 3.91668C9.90262 3.75001 10.0971 3.66668 10.3332 3.66668C10.5693 3.66668 10.7707 3.75001 10.9373 3.91668Z"
        fill="currentColor"
      />
    </svg>
  );
}

const MemoArrowIcon = React.memo(ArrowIcon);
export default MemoArrowIcon;
